module.exports = __webpack_public_path__ + "img/icon4.fb744d32.png";